// src/ui/App.tsx
import { useEffect, useState } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import Onboarding from "./screens/Onboarding";
import Measurement from "./screens/Measurement";
import Result from "./screens/Result";
import History from "./screens/History";
import Compare from "./screens/Compare";
import Settings from "./screens/Settings";
import InstallPrompt from "./components/InstallPrompt";
import { requestPersistentStorage } from "../storage/db";
import { track } from "../services/analytics";

const ONBOARDING_DONE_KEY = "kinemalens_onboarding_done";

export default function App() {
  const [onboardingDone, setOnboardingDone] = useState(
    () => localStorage.getItem(ONBOARDING_DONE_KEY) === "true",
  );

  useEffect(() => {
    track("app_opened");
    void requestPersistentStorage();
  }, []);

  return (
    <HashRouter>
      <InstallPrompt />
      <Routes>
        <Route
          path="/"
          element={
            onboardingDone ? (
              <Navigate to="/measure" replace />
            ) : (
              <Onboarding
                onComplete={() => {
                  localStorage.setItem(ONBOARDING_DONE_KEY, "true");
                  setOnboardingDone(true);
                  track("onboarding_completed");
                }}
              />
            )
          }
        />
        <Route path="/measure" element={<Measurement />} />
        <Route path="/result/:sessionId" element={<Result />} />
        <Route path="/history" element={<History />} />
        <Route path="/compare" element={<Compare />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/measure" replace />} />
      </Routes>
    </HashRouter>
  );
}
